
import React, { useState, useContext } from 'react';
import Slider from 'react-slick';
import { GlobalContext } from './GlobalContext';
export default function SportSelection(props) {

  const { isH2H, setIsH2H, geolocation } = useContext(GlobalContext);
  const h2hOnly = document.getElementById('h2h-only').value == 1;

  let emoji = {
    'nba': '🏀',
    'cbb': '🏀',
    'wnba': '🏀',
    'wcbb': '🏀',
    '3pt': '🏀',
    'nfl': '🏈',
    'mlb': '⚾️',
    'kbo': '⚾️',
    'nhl': '🏒',
    'ufc': '👊',
    'cfb': '🏈',
    'pga': '⛳️',
    'soccer': '⚽️',
    'cs2': '🎮',
    'lol': '🐉',
    'val': '🛡️',
    'cod': '🪖',
    'dota2': '🔮',
    'r6' : '6️⃣',
    'tennis': '🎾',
    'f1': '🏎',
    'darts': '🎯',
    'boxing': '🥊',
    'allstar': '⭐️',
    'nascar': '🏎',
    'fpa': '🏀',
    'fiba': '🏀',
    'hotdog': '🌭',
    'cfl': '🏈',
  };

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => ('');
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => ('');

  // Slider settings
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 4,
    nextArrow: <SlickArrowRight />,
    prevArrow: <SlickArrowLeft />,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 4 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 3 }
      }
    ],
  };

  const handleToggleH2h = () => {

    if (h2hOnly) {
      alert(`${geolocation} is limited to Head-to-Head entries.`);
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const opponentOid = urlParams.get('h2h');
    if (opponentOid) {
      $('#h2h-match-modal').modal('show');
      return;
    }

    setIsH2H(!isH2H);
    if (!isH2H) {
      $('#h2h-modal').modal('show');
    }
  }

  return (

      <Slider {...settings}>

        { isH2H && document.body.classList.contains('logged-in') && document.getElementById('verified').value == '1' &&
          <button onClick={handleToggleH2h} data-prop='h2h' className={'sport-btn select-btn' + (isH2H ? ' selected' : '')} value={isH2H}>
            <div><i class="fa-solid fa-user-group"></i></div>
            H2H
          </button>
        }

        {Object.keys(props.sports).map((sport) => (
          <button onClick={(e) => props.onClick(e)} data-prop='sport' className={'sport-btn select-btn' + (props.sport === props.sports[sport] ? ' selected' : '')} value={props.sports[sport]}>
            <div>{emoji[props.sports[sport]]}</div>
            {props.sports[sport].toUpperCase()}
          </button>
        ))}
      </Slider>

  );
}